var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPharmacovigilanceDecorIcon = function SvgPharmacovigilanceDecorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 265 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.221 88V0c-24.354 0-44.096 19.699-44.096 44 0 24.3 19.742 44 44.096 44Z",
    fill: "#D70000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.127 88H89.031V0c24.354 0 44.096 19.699 44.096 44v44ZM89.025 0H44.93v88h44.095V0ZM.834 0v88C25.188 88 44.93 68.301 44.93 44c0-24.3-19.742-44-44.096-44ZM221.026 43.712 264.834 0H177.219l43.807 43.712ZM221.005 43.718l-21.903 21.855 21.903 21.856 21.903-21.856-21.903-21.855Z",
    fill: "#D70000"
  })));
};
export default SvgPharmacovigilanceDecorIcon;